import * as z from "zod";
import { triggerOrderSchema } from "./common";

export const getTriggerOrder = {
  name: "getTriggerOrder" as const,
  input: z.object({ triggerKind: z.string() }),
  output: z.object({ order: triggerOrderSchema }),
};
